(() => {
  const root = document.querySelector('[data-shop-collection]');
  if (!root) return;
  const categories = root.querySelector('[data-shop-categories]');
  if (!categories) return;

  const buttons = [...categories.querySelectorAll('[data-shop-category]')];
  const validIds = new Set(buttons.map((button) => button.dataset.shopCategory));
  const selectedFromUrl = () => {
    const requested = new URL(window.location.href).searchParams.get('shop_category');
    return validIds.has(requested) ? requested : 'all';
  };
  let active = selectedFromUrl();

  const update = () => {
    const items = [...root.querySelectorAll('#product-grid .shop-collection__item')];
    let visible = 0;
    items.forEach((item) => {
      const matches = active === 'all' || item.dataset.shopCategoryIds?.includes(`|${active}|`);
      item.hidden = !matches;
      if (matches) visible += 1;
    });
    buttons.forEach((button) => {
      const selected = button.dataset.shopCategory === active;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    const count = root.querySelector('[data-shop-count]');
    if (count) count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
    const showing = root.querySelector('[data-shop-showing]');
    if (showing) showing.textContent = `Showing ${visible} of ${items.length}`;
    const empty = root.querySelector('[data-shop-empty]');
    if (empty) empty.hidden = visible !== 0;
  };

  categories.hidden = false;
  categories.addEventListener('click', (event) => {
    const button = event.target.closest('[data-shop-category]');
    if (!button || !categories.contains(button)) return;
    active = button.dataset.shopCategory;
    const url = new URL(window.location.href);
    if (active === 'all') url.searchParams.delete('shop_category');
    else url.searchParams.set('shop_category', active);
    window.history.pushState({ shopCategory: active }, '', url);
    update();
  });
  window.addEventListener('popstate', () => {
    active = selectedFromUrl();
    update();
  });
  const results = root.querySelector('#ProductGridContainer');
  if (results) new MutationObserver(update).observe(results, { childList: true, subtree: false });
  update();
})();
